module.exports = __webpack_public_path__ + "files/822ed07e0cadc00e2955924c885f3ea3.png";